var _style, _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _defs39, _defs40, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46, _defs47, _defs48, _defs49, _defs50, _defs51, _defs52, _defs53, _defs54, _defs55, _defs56, _defs57, _defs58, _defs59, _defs60, _defs61, _defs62, _defs63, _defs64, _defs65, _defs66, _defs67, _defs68, _defs69, _defs70, _defs71, _defs72, _defs73, _defs74, _defs75, _defs76, _defs77, _defs78, _defs79, _defs80, _defs81, _defs82, _defs83, _defs84, _defs85, _defs86, _defs87, _defs88, _defs89, _defs90, _defs91, _defs92;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKpi4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 175.2 163.5",
    style: {
      enableBackground: "new 0 0 175.2 163.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{clip-path:url(#SVGID_00000065067647741128454340000009947256288036007096_);}\n\t.st2{clip-path:url(#SVGID_00000026868049580840103560000012879010628121436837_);}\n\t.st3{clip-path:url(#SVGID_00000114770520128148288550000011830836400095605645_);fill:#808080;}\n\t.st4{clip-path:url(#SVGID_00000151515997008063201160000015047716499269095085_);}\n\t.st5{clip-path:url(#SVGID_00000085972959923617412100000009897785660095316608_);}\n\t.st6{clip-path:url(#SVGID_00000137119842919168419680000011551796517528267914_);fill:#808080;}\n\t.st7{clip-path:url(#SVGID_00000072261157952143504380000010829269896282706593_);}\n\t.st8{clip-path:url(#SVGID_00000021807608978417726340000017678159017782417593_);}\n\t.st9{clip-path:url(#SVGID_00000109731547600526072220000013053598549669946521_);fill:#808080;}\n\t.st10{clip-path:url(#SVGID_00000081646974581557680080000016221066211525948564_);}\n\t.st11{clip-path:url(#SVGID_00000113313959299042754050000015599509290327134102_);}\n\t.st12{clip-path:url(#SVGID_00000047781388967173903290000001531302827031543945_);fill:#808080;}\n\t.st13{clip-path:url(#SVGID_00000031186184283094755020000003810896154577178271_);}\n\t.st14{clip-path:url(#SVGID_00000101081522406228408690000001329094315978754743_);}\n\t.st15{clip-path:url(#SVGID_00000049198499619467184680000005180482319445222315_);fill:#808080;}\n\t.st16{clip-path:url(#SVGID_00000057839145678633736190000000873447154330291876_);}\n\t.st17{clip-path:url(#SVGID_00000041292329477953295390000005631807894357661320_);}\n\t.st18{clip-path:url(#SVGID_00000122693829200063410890000008552250507820299144_);fill:#808080;}\n\t.st19{clip-path:url(#SVGID_00000020389827960837412300000002143873991998569872_);}\n\t.st20{clip-path:url(#SVGID_00000084520753148712401460000005634646482189884045_);}\n\t.st21{clip-path:url(#SVGID_00000085970102285851603260000013178555147151912122_);}\n\t.st22{clip-path:url(#SVGID_00000144328889868341973560000012079340188559347373_);}\n\t.st23{clip-path:url(#SVGID_00000156566078803312088400000005371376306310602658_);}\n\t.st24{clip-path:url(#SVGID_00000066480824578815212370000000679219257788519095_);}\n\t.st25{clip-path:url(#SVGID_00000177478723520727971570000000061620727263563684_);fill:#808080;}\n\t.st26{clip-path:url(#SVGID_00000017497348704069464210000011312313114289607043_);}\n\t.st27{clip-path:url(#SVGID_00000183214818377133981990000005779902432316252810_);}\n\t.st28{clip-path:url(#SVGID_00000078010588158794396790000010870877931564037252_);fill:#808080;}\n\t.st29{clip-path:url(#SVGID_00000028315166877042782830000007370016176758386074_);}\n\t.st30{clip-path:url(#SVGID_00000033368863075265903600000009188564251088608671_);}\n\t.st31{clip-path:url(#SVGID_00000111166169465009529090000017224104044858724503_);fill:#808080;}\n\t.st32{clip-path:url(#SVGID_00000091003060541583211840000017014051104646775227_);}\n\t.st33{clip-path:url(#SVGID_00000142163116347746116350000017458088349963304332_);}\n\t.st34{clip-path:url(#SVGID_00000181778372593202137330000008624281856255011728_);fill:#808080;}\n\t.st35{clip-path:url(#SVGID_00000129166170953099713260000000516771814338982538_);}\n\t.st36{clip-path:url(#SVGID_00000151524190724152552800000010786172063433811383_);}\n\t.st37{clip-path:url(#SVGID_00000092456766452065726350000014340325060495016869_);fill:#808080;}\n\t.st38{clip-path:url(#SVGID_00000105421205413873994510000001258482429474591156_);}\n\t.st39{clip-path:url(#SVGID_00000096747304141350389920000004730817046384769668_);}\n\t.st40{clip-path:url(#SVGID_00000096046538551260313610000010530487016622700697_);fill:#808080;}\n\t.st41{clip-path:url(#SVGID_00000149354308302739987740000014622853961251389360_);}\n\t.st42{clip-path:url(#SVGID_00000095339662120430124610000011728786732181963180_);}\n\t.st43{clip-path:url(#SVGID_00000069374005825489757110000001664376890995580820_);fill:#808080;}\n\t.st44{clip-path:url(#SVGID_00000174596061218251245250000011489555937440754098_);}\n\t.st45{clip-path:url(#SVGID_00000104685031916565173710000000037623957167828927_);}\n\t.st46{clip-path:url(#SVGID_00000057139982265688944800000006365086664065063303_);fill:#808080;}\n\t.st47{clip-path:url(#SVGID_00000170265598755911846950000010675439461774138807_);}\n\t.st48{clip-path:url(#SVGID_00000114048670922153153760000000721496061646823045_);}\n\t.st49{clip-path:url(#SVGID_00000096019323656857334340000009245653596425207720_);fill:#808080;}\n\t.st50{clip-path:url(#SVGID_00000046325061282582583810000004576309330889170362_);}\n\t.st51{clip-path:url(#SVGID_00000103961413053838528140000017908705820890318478_);}\n\t.st52{clip-path:url(#SVGID_00000000214735516548452190000015520534709621978269_);fill:#808080;}\n\t.st53{clip-path:url(#SVGID_00000001665044535874043190000002923118664649898927_);}\n\t.st54{clip-path:url(#SVGID_00000029753928336273975920000016588159437363561384_);}\n\t.st55{clip-path:url(#SVGID_00000080171148992424266650000000318627981403660730_);fill:#808080;}\n\t.st56{clip-path:url(#SVGID_00000088119663492984798340000014174842681703713716_);}\n\t.st57{clip-path:url(#SVGID_00000059297793241518012450000009491929264561250976_);}\n\t.st58{clip-path:url(#SVGID_00000070812520330436204770000013824263500696007059_);fill:#808080;}\n\t.st59{clip-path:url(#SVGID_00000059280500741182229840000000682436766875182776_);}\n\t.st60{clip-path:url(#SVGID_00000029041002402100981260000010578184674844462747_);}\n\t.st61{clip-path:url(#SVGID_00000177477196760648108120000009174967396243022751_);fill:#808080;}\n\t.st62{clip-path:url(#SVGID_00000142141751698774030380000016103134868904455048_);}\n\t.st63{clip-path:url(#SVGID_00000101810652234353221730000000513255730768871565_);}\n\t.st64{clip-path:url(#SVGID_00000150100346471421090390000008439951676518124720_);fill:#808080;}\n\t.st65{clip-path:url(#SVGID_00000104683057372057060290000002238474890650800001_);}\n\t.st66{clip-path:url(#SVGID_00000130605888710082587080000015637324441950847166_);}\n\t.st67{clip-path:url(#SVGID_00000084491923100762819620000010729096029498373807_);fill:#808080;}\n\t.st68{clip-path:url(#SVGID_00000058580547061279372700000016818051238362894231_);}\n\t.st69{clip-path:url(#SVGID_00000124864219114823777450000012086522616860257468_);}\n\t.st70{clip-path:url(#SVGID_00000135655465507663115280000007419442607660515459_);fill:#808080;}\n\t.st71{clip-path:url(#SVGID_00000167366043658563682730000017763921534883100304_);}\n\t.st72{clip-path:url(#SVGID_00000046314675290076889580000008507545093435941005_);}\n\t.st73{clip-path:url(#SVGID_00000093860986513472122390000007918144956546590106_);fill:#808080;}\n\t.st74{clip-path:url(#SVGID_00000016793586074073208170000004266600627259800750_);}\n\t.st75{clip-path:url(#SVGID_00000114786666844322319430000007213985454943981733_);}\n\t.st76{clip-path:url(#SVGID_00000092449383341691457560000004126537217391145112_);fill:#808080;}\n\t.st77{clip-path:url(#SVGID_00000125594632746690444520000017942640904262518159_);}\n\t.st78{clip-path:url(#SVGID_00000116211116017672232390000009460824553133697681_);}\n\t.st79{clip-path:url(#SVGID_00000067225822974919250240000015819875030039046025_);fill:#808080;}\n\t.st80{clip-path:url(#SVGID_00000020400831529847406480000009407894981324833678_);}\n\t.st81{clip-path:url(#SVGID_00000178885756182022724620000014229515508173106334_);}\n\t.st82{clip-path:url(#SVGID_00000137814272350205251400000017094882511778429610_);fill:#808080;}\n\t.st83{clip-path:url(#SVGID_00000119824305564465421880000011430190772499611026_);}\n\t.st84{clip-path:url(#SVGID_00000157286538664192922390000016797672152002519228_);}\n\t.st85{clip-path:url(#SVGID_00000158014161165583115490000012000533326701690809_);fill:#808080;}\n\t.st86{clip-path:url(#SVGID_00000160171327613504345520000017963227837600542082_);}\n\t.st87{clip-path:url(#SVGID_00000176004801801689912310000001727839367250268841_);}\n\t.st88{clip-path:url(#SVGID_00000142881363728838627450000004977987226961117065_);fill:#808080;}\n\t.st89{clip-path:url(#SVGID_00000029744820527135959290000004006646967255729833_);}\n\t.st90{clip-path:url(#SVGID_00000165938985292975918090000015560889539123558535_);fill:#808080;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 174,
    height: 129,
    xlinkHref: "AF267CD7290434E1.png",
    transform: "matrix(0.9935 0 0 0.9935 1.6615 24.0568)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 24.1,
    className: "st0",
    width: 173,
    height: 128
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022539155073488553600000007643078063524311959_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022539155073488553600000007643078063524311959_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000080193895436944788340000005839364221235198123_",
    d: "M30.2,76c-0.4-2.5-2.5-4.5-5.2-4.5 c-2.9,0-5.2,2.3-5.2,5.2c0,2.9,2.3,5.2,5.2,5.2c2.6,0,4.8-1.9,5.2-4.5h8.9c0.1-0.5,0.2-1,0.4-1.5h-9.3V76z M25,80.5 c-2,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7S27.1,80.5,25,80.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070078375851251572920000015411165462207081141_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080193895436944788340000005839364221235198123_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000070078375851251572920000015411165462207081141_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000044877818052464447700000004101182057358716607_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005973930277703696550000011387862777091065259_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044877818052464447700000004101182057358716607_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 70.5,
    style: {
      clipPath: "url(#SVGID_00000005973930277703696550000011387862777091065259_)",
      fill: "#808080"
    },
    width: 21.6,
    height: 12.4
  })))))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000008129842026494043680000007423056042901837488_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132796386673344534670000012473662637962994824_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008129842026494043680000007423056042901837488_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000132796386673344534670000012473662637962994824_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000127731352714954379610000013850727312279923372_",
    d: "M25,81.5c-2.6,0-4.7-2.1-4.7-4.7s2.1-4.7,4.7-4.7 c2.3,0,4.3,1.7,4.7,4l0.1,0.4h9c0,0.2-0.1,0.3-0.1,0.5h-8.9l-0.1,0.4C29.3,79.8,27.3,81.5,25,81.5 M25,72.6 c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2C29.2,74.4,27.3,72.6,25,72.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108309979732300582310000008042049085199251109_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127731352714954379610000013850727312279923372_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000108309979732300582310000008042049085199251109_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000147210877458998430480000008965467364382295480_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075856807063499663560000008923782909777434795_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147210877458998430480000008965467364382295480_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.3,
    y: 71.1,
    style: {
      clipPath: "url(#SVGID_00000075856807063499663560000008923782909777434795_)",
      fill: "#808080"
    },
    width: 20.5,
    height: 11.4
  })))))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000089568285978377673320000008058224769008917430_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160881758875950922490000010255195317902994305_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089568285978377673320000008058224769008917430_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000160881758875950922490000010255195317902994305_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000043447682078818946270000004309210672344824203_",
    d: "M146,77.5c0.4,2.5,2.5,4.5,5.2,4.5 c2.9,0,5.2-2.3,5.2-5.2c0-2.9-2.3-5.2-5.2-5.2c-2.6,0-4.8,1.9-5.2,4.5h-9.2c0.1,0.5,0.2,1,0.4,1.5h8.8V77.5z M151.2,73.1 c2,0,3.7,1.7,3.7,3.7s-1.7,3.7-3.7,3.7s-3.7-1.7-3.7-3.7C147.5,74.7,149.1,73.1,151.2,73.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114075799250552016450000011507319961145857445_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000043447682078818946270000004309210672344824203_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114075799250552016450000011507319961145857445_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000144312325359076981370000008290700588040099204_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124844307168874422540000017799368022825691561_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000144312325359076981370000008290700588040099204_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 135.8,
    y: 70.6,
    style: {
      clipPath: "url(#SVGID_00000124844307168874422540000017799368022825691561_)",
      fill: "#808080"
    },
    width: 21.6,
    height: 12.4
  })))))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000091719664641220736780000008110008594248525234_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057126098978718148410000000360246624531010469_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091719664641220736780000008110008594248525234_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057126098978718148410000000360246624531010469_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000007418831672335878140000003914843746978270112_",
    d: "M151.2,81.5c-2.3,0-4.3-1.7-4.7-4l-0.1-0.4h-8.9 c0-0.2-0.1-0.3-0.1-0.5h9l0.1-0.4c0.3-2.3,2.3-4,4.7-4c2.6,0,4.7,2.1,4.7,4.7C155.9,79.4,153.8,81.5,151.2,81.5 M151.2,72.6 c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2C155.4,74.4,153.5,72.6,151.2,72.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091702744410049028390000005476649180034185389_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007418831672335878140000003914843746978270112_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000091702744410049028390000005476649180034185389_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000176764235124743119940000009283586612929146255_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057828134237117593170000010820691540970483858_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176764235124743119940000009283586612929146255_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 136.4,
    y: 71.1,
    style: {
      clipPath: "url(#SVGID_00000057828134237117593170000010820691540970483858_)",
      fill: "#808080"
    },
    width: 20.5,
    height: 11.4
  })))))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070820059428141222090000004797733555052725156_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054233883213971161000000001828045369418733191_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070820059428141222090000004797733555052725156_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054233883213971161000000001828045369418733191_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000151544806274103853370000012132493393731072154_",
    d: "M25,75.5c-0.7,0-1.3,0.6-1.3,1.3 c0,0.7,0.6,1.2,1.3,1.2s1.3-0.6,1.3-1.2C26.3,76.1,25.7,75.5,25,75.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095313781024309796750000017663625078243286459_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151544806274103853370000012132493393731072154_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000095313781024309796750000017663625078243286459_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000086671273385057303220000011268945072134536610_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163784503927924399390000015421140392866581927_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086671273385057303220000011268945072134536610_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 74.5,
    style: {
      clipPath: "url(#SVGID_00000163784503927924399390000015421140392866581927_)",
      fill: "#808080"
    },
    width: 4.5,
    height: 4.5
  })))))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000041265488579175562750000007482784227593587350_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100355653996369952990000012201309188335420061_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041265488579175562750000007482784227593587350_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000100355653996369952990000012201309188335420061_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000079485518459677748170000017095350067971521672_",
    d: "M25,77.5c-0.4,0-0.7-0.3-0.7-0.7 c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7C25.8,77.2,25.4,77.5,25,77.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106108056210699884480000006059743181864597148_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079485518459677748170000017095350067971521672_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106108056210699884480000006059743181864597148_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000179621151094551491800000008819972962699050655_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139998221734459494620000017756495952445759125_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179621151094551491800000008819972962699050655_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 23.3,
    y: 75,
    style: {
      clipPath: "url(#SVGID_00000139998221734459494620000017756495952445759125_)",
      fill: "#808080"
    },
    width: 3.5,
    height: 3.5
  })))))), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000013907551857765532500000000291227587928432039_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139981393300300451330000010589926045640162491_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013907551857765532500000000291227587928432039_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139981393300300451330000010589926045640162491_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000062176294520319105300000001586101165109390509_",
    d: "M24.1,104.7c-0.4-3-2.9-5.2-6-5.2c-3.3,0-6,2.7-6,6 s2.7,6,6,6c3.1,0,5.6-2.3,6-5.2h17.1c-0.2-0.5-0.4-1-0.5-1.5H24.1V104.7z M18.1,109.9c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5 s4.5,2,4.5,4.5S20.6,109.9,18.1,109.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181774313332961236360000010238282791028624282_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062176294520319105300000001586101165109390509_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181774313332961236360000010238282791028624282_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000100352122095125196510000010330069476455442852_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009562791356539001210000006452698983345315226_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100352122095125196510000010330069476455442852_",
    style: {
      overflow: "visible"
    }
  }))))))), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000021805467328590214600000000624980277989739907_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153696129693932639160000003333473759148415662_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021805467328590214600000000624980277989739907_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000153696129693932639160000003333473759148415662_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000025419835804009385800000014145990118111583627_",
    d: "M18.1,100.4c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5 C23.1,102.7,20.9,100.4,18.1,100.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162310553320903576510000009510661182699295629_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000025419835804009385800000014145990118111583627_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000162310553320903576510000009510661182699295629_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000035529723123206705930000009646631001979994554_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108292762022490367300000012291620955135784098_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035529723123206705930000009646631001979994554_",
    style: {
      overflow: "visible"
    }
  }))))))), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000021805183560484660610000000560107216042350270_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057106588236715227550000011604998286699347588_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021805183560484660610000000560107216042350270_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057106588236715227550000011604998286699347588_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000032642414887003920590000001198797406841079731_",
    d: "M152.1,106.2c0.4,3,2.9,5.2,6,5.2c3.3,0,6-2.7,6-6 s-2.7-6-6-6c-3.1,0-5.6,2.3-6,5.2h-16.5c-0.2,0.5-0.4,1-0.5,1.5h17V106.2z M158.1,101c2.5,0,4.5,2,4.5,4.5s-2,4.5-4.5,4.5 s-4.5-2-4.5-4.5S155.6,101,158.1,101z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120518080174784186220000006222186283580032422_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000032642414887003920590000001198797406841079731_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000120518080174784186220000006222186283580032422_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000025417219325720271720000018420583163299152813_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023252989089444809080000000343817030652052896_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000025417219325720271720000018420583163299152813_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134.1,
    y: 98.4,
    style: {
      clipPath: "url(#SVGID_00000023252989089444809080000000343817030652052896_)",
      fill: "#808080"
    },
    width: 31,
    height: 14
  })))))), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000083800575729015399620000009396525819618869403_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000135660871401303244020000016197527998656434602_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083800575729015399620000009396525819618869403_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000135660871401303244020000016197527998656434602_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000098198640734769601800000014804661010142088098_",
    d: "M158.1,110.9c-2.8,0-5.1-2.1-5.5-4.8l-0.1-0.4h-16.8 c0.1-0.2,0.1-0.3,0.2-0.5h16.6l0.1-0.4c0.4-2.7,2.7-4.8,5.5-4.8c3,0,5.5,2.5,5.5,5.5C163.6,108.5,161.1,110.9,158.1,110.9  M158.1,100.4c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5C163.1,102.7,160.8,100.4,158.1,100.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053508968760051888520000011193138978055608500_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098198640734769601800000014804661010142088098_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000053508968760051888520000011193138978055608500_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000030481468893079313630000002653524327399777667_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000133521405544731258760000013548927531697384122_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000030481468893079313630000002653524327399777667_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134.8,
    y: 99,
    style: {
      clipPath: "url(#SVGID_00000133521405544731258760000013548927531697384122_)",
      fill: "#808080"
    },
    width: 29.8,
    height: 13
  })))))), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000053506507135770447080000006465921636465671348_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085952110372111356510000017486644137235660717_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053506507135770447080000006465921636465671348_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000085952110372111356510000017486644137235660717_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000037693794771125362050000008430064086160901542_",
    d: "M158.1,106.9c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5 s-1.5,0.7-1.5,1.5C156.6,106.3,157.3,106.9,158.1,106.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000143595266837139501050000012091564394260750781_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000037693794771125362050000008430064086160901542_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000143595266837139501050000012091564394260750781_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000103241700931139622560000015685280921862175637_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181057284976047329270000001484350317291927719_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103241700931139622560000015685280921862175637_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 155.6,
    y: 103,
    style: {
      clipPath: "url(#SVGID_00000181057284976047329270000001484350317291927719_)",
      fill: "#808080"
    },
    width: 5,
    height: 4.9
  })))))), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000137827874209355375730000012477998052034121875_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080899586492556501250000014770895715399244470_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137827874209355375730000012477998052034121875_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080899586492556501250000014770895715399244470_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000126282026493268650440000003972872340242050232_",
    d: "M158.1,106.4c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1 s1,0.4,1,1C159,106,158.6,106.4,158.1,106.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154398997023614120420000017810574850366914944_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000126282026493268650440000003972872340242050232_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000154398997023614120420000017810574850366914944_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000030478083943748279920000011096273742933201567_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116943388693578352050000003620384647991172031_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000030478083943748279920000011096273742933201567_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 156.1,
    y: 103.5,
    style: {
      clipPath: "url(#SVGID_00000116943388693578352050000003620384647991172031_)",
      fill: "#808080"
    },
    width: 3.9,
    height: 3.9
  })))))), /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000052098702203324258680000009910758319960782502_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013187025590202643200000014897940378760750727_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052098702203324258680000009910758319960782502_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013187025590202643200000014897940378760750727_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000135651101839255168160000014113615668474918272_",
    d: "M133.6,88.4c0-25-20.4-45.4-45.5-45.4 S42.6,63.4,42.6,88.4s20.4,45.4,45.5,45.4S133.6,113.4,133.6,88.4 M44.5,88.4c0-24,19.6-43.6,43.6-43.6 c24.1,0,43.6,19.5,43.6,43.6c0,24-19.6,43.6-43.6,43.6C64,132,44.5,112.4,44.5,88.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002381516963846982560000015666592595132397716_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135651101839255168160000014113615668474918272_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000002381516963846982560000015666592595132397716_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000116924888386031208910000005305952681033488802_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072260390805416280100000017236001274842777261_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116924888386031208910000005305952681033488802_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.6,
    y: 42,
    style: {
      clipPath: "url(#SVGID_00000072260390805416280100000017236001274842777261_)",
      fill: "#808080"
    },
    width: 92.9,
    height: 92.8
  })))))), /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000042707728075777334590000000096458046743556017_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050640730117247191340000004447163155226591671_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042707728075777334590000000096458046743556017_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000050640730117247191340000004447163155226591671_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000105404458599562698070000004395245707701686953_",
    d: "M88.1,133.3c-24.8,0-45-20.1-45-44.9 c0-24.7,20.2-44.9,45-44.9s45,20.1,45,44.9S112.9,133.3,88.1,133.3 M88.1,44.3C63.8,44.3,44,64.1,44,88.4s19.8,44.1,44.1,44.1 s44.1-19.8,44.1-44.1C132.3,64.1,112.5,44.3,88.1,44.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095339077116057569890000003068899036292771969_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000105404458599562698070000004395245707701686953_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000095339077116057569890000003068899036292771969_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000081611360893655775660000015910769822357323920_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075857227692805528530000015471459472014791576_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000081611360893655775660000015910769822357323920_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 42.2,
    y: 42.5,
    style: {
      clipPath: "url(#SVGID_00000075857227692805528530000015471459472014791576_)",
      fill: "#808080"
    },
    width: 91.9,
    height: 91.8
  })))))), /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070101898429336428370000009089252694306372533_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041286344306478660950000006789539550988116662_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070101898429336428370000009089252694306372533_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000041286344306478660950000006789539550988116662_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000003067168055824675620000003596237618394924450_",
    d: "M97.2,36.7l0.2-1.2c-6.3-1.1-12.9-1.1-19.1,0.1 l0.2,1.2C84.6,35.7,91,35.7,97.2,36.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080919411892148988600000012746142632305430443_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003067168055824675620000003596237618394924450_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080919411892148988600000012746142632305430443_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000097501801867489720680000004117176359988013753_",
    x: 78.3,
    y: 34.7,
    width: 19.1,
    height: 3.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075143149846384969510000014190693956789095088_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000097501801867489720680000004117176359988013753_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 77.3,
    y: 33.7,
    style: {
      clipPath: "url(#SVGID_00000075143149846384969510000014190693956789095088_)",
      fill: "#808080"
    },
    width: 21.1,
    height: 4.1
  })))))), /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000067202393535170788550000006858021075617118129_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006673600464441739470000000929577079065234874_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067202393535170788550000006858021075617118129_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000006673600464441739470000000929577079065234874_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000071531362941140718830000003977617734369556920_",
    d: "M78.9,36c3-0.5,6.1-0.8,9.2-0.8 c2.9,0,5.8,0.2,8.7,0.7v0.2c-2.8-0.5-5.7-0.7-8.6-0.7c-3.1,0-6.2,0.3-9.2,0.8L78.9,36z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151524084680178301220000006129316160831556497_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071531362941140718830000003977617734369556920_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000151524084680178301220000006129316160831556497_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000079446294793676823240000000936752168641055125_",
    x: 78.9,
    y: 34.7,
    width: 17.9,
    height: 3.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140000819521071733900000005938881825662579588_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079446294793676823240000000936752168641055125_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 77.9,
    y: 34.2,
    style: {
      clipPath: "url(#SVGID_00000140000819521071733900000005938881825662579588_)",
      fill: "#808080"
    },
    width: 19.9,
    height: 3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000079461086858976258040000014674627004218978200_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043418811517469977260000004064668165635096467_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079461086858976258040000014674627004218978200_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000043418811517469977260000004064668165635096467_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000030446326916230430030000009889873011765931957_",
    d: "M70.5,38.9l-0.4-1.2c-15.3,5.4-27.6,17.8-32.9,33.1 l1.2,0.4C43.6,56.3,55.6,44.2,70.5,38.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060026333937575368020000012584014458512488629_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000030446326916230430030000009889873011765931957_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060026333937575368020000012584014458512488629_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000062887020846767191350000017242899759621761933_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127735050962089022360000015724933712897092745_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062887020846767191350000017242899759621761933_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 36.8,
    style: {
      clipPath: "url(#SVGID_00000127735050962089022360000015724933712897092745_)",
      fill: "#808080"
    },
    width: 35.3,
    height: 35.5
  })))))), /*#__PURE__*/React.createElement("g", null, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114763953998117760110000001540792250137318327_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176756979292195248740000009819819624486458504_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114763953998117760110000001540792250137318327_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000176756979292195248740000009819819624486458504_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000001654831670844199040000002438071941286769332_",
    d: "M37.9,70.5c5.3-14.8,17.2-26.7,31.9-32.1l0.1,0.2 c-14.7,5.4-26.5,17.3-31.8,32L37.9,70.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180326714659267130080000007318196762242320043_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001654831670844199040000002438071941286769332_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000180326714659267130080000007318196762242320043_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000075843932378142439780000011431126605852144046_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004520209914408685850000012942395557097611653_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075843932378142439780000011431126605852144046_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.9,
    y: 37.4,
    style: {
      clipPath: "url(#SVGID_00000004520209914408685850000012942395557097611653_)",
      fill: "#808080"
    },
    width: 34,
    height: 34.1
  })))))), /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000018927776622708751480000003312762083049481625_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018926183065208783630000014224465470034880167_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018927776622708751480000003312762083049481625_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000018926183065208783630000014224465470034880167_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000160904478142610733880000006546172321660199554_",
    d: "M34.7,81.7c-0.3,2.2-0.4,4.5-0.4,6.7 c0,4.2,0.5,8.5,1.5,12.6l1.2-0.3c-1-4-1.4-8.1-1.4-12.3c0-2.2,0.1-4.4,0.4-6.6L34.7,81.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000079458042429058064840000015300357767295608750_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160904478142610733880000006546172321660199554_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000079458042429058064840000015300357767295608750_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000176013805597531678550000008439276239303826576_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049911344574714356200000012308798171637090211_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176013805597531678550000008439276239303826576_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.3,
    y: 80.7,
    style: {
      clipPath: "url(#SVGID_00000049911344574714356200000012308798171637090211_)",
      fill: "#808080"
    },
    width: 4.7,
    height: 21.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000068655793658025524240000016898655064181167290_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000210583341940394100000005720350139056233619_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000068655793658025524240000016898655064181167290_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000000210583341940394100000005720350139056233619_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000018922331721415060990000011518233023087329924_",
    d: "M36.2,100.3c-0.9-3.9-1.3-7.9-1.3-11.9 c0-2.1,0.1-4.1,0.4-6.2h0.2c-0.2,2-0.4,4.1-0.4,6.1c0,4,0.4,8,1.3,11.9L36.2,100.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182492121093330555410000010933922578861963711_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018922331721415060990000011518233023087329924_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182492121093330555410000010933922578861963711_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000175282239483831434370000015140901523498931121_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054231481044150066680000006902862318755539090_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175282239483831434370000015140901523498931121_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.8,
    y: 81.2,
    style: {
      clipPath: "url(#SVGID_00000054231481044150066680000006902862318755539090_)",
      fill: "#808080"
    },
    width: 3.5,
    height: 20.1
  })))))), /*#__PURE__*/React.createElement("g", null, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000160190480198874629990000011017272506803689360_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004505518314792019170000005243479378512253364_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160190480198874629990000011017272506803689360_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000004505518314792019170000005243479378512253364_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000009553552038723277640000012242281387137385633_",
    d: "M68.9,138.6l0.4-1.1c-12.7-4.8-23.2-14.7-28.9-27 l-1.1,0.5C45.1,123.6,55.9,133.6,68.9,138.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085941249543998777210000014391003588619425183_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009553552038723277640000012242281387137385633_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000085941249543998777210000014391003588619425183_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000133494366482051101690000006779934201904554375_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134233972495813657250000010696651464620108949_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000133494366482051101690000006779934201904554375_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.3,
    y: 109.5,
    style: {
      clipPath: "url(#SVGID_00000134233972495813657250000010696651464620108949_)",
      fill: "#808080"
    },
    width: 32,
    height: 30.1
  })))))), /*#__PURE__*/React.createElement("g", null, _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000171689245957973309010000016800200752145055917_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160886140665861491250000008001779863348234656_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171689245957973309010000016800200752145055917_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000160886140665861491250000008001779863348234656_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000156556530423047966970000014838483276953725056_",
    d: "M68.6,137.9C56.1,133,45.8,123.3,40,111.3l0.2-0.1 C45.9,123.2,56.3,132.9,68.6,137.9L68.6,137.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102533344726437755170000009180672409901333130_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156556530423047966970000014838483276953725056_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000102533344726437755170000009180672409901333130_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000030465986800462797480000004578127304497263755_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075133050711900016370000001505581846193578406_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000030465986800462797480000004578127304497263755_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 110.2,
    style: {
      clipPath: "url(#SVGID_00000075133050711900016370000001505581846193578406_)",
      fill: "#808080"
    },
    width: 30.7,
    height: 28.7
  })))))), /*#__PURE__*/React.createElement("g", null, _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000130618593886723497060000017228980820369610665_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176023489557085181230000004365135068065467316_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130618593886723497060000017228980820369610665_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000176023489557085181230000004365135068065467316_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000059277976317198589060000008356193006539348630_",
    d: "M105.8,37.8l-0.4,1.2c14.9,5.3,26.9,17.4,32.1,32.3 l1.2-0.4C133.4,55.6,121.1,43.2,105.8,37.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114773538311773788680000011423680967337137085_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059277976317198589060000008356193006539348630_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114773538311773788680000011423680967337137085_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000068656724297545199160000006910888302094305980_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139266610496217340330000008618599918406193833_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000068656724297545199160000006910888302094305980_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 104.4,
    y: 36.8,
    style: {
      clipPath: "url(#SVGID_00000139266610496217340330000008618599918406193833_)",
      fill: "#808080"
    },
    width: 35.3,
    height: 35.5
  })))))), /*#__PURE__*/React.createElement("g", null, _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000019638048640724421680000009219378204957398912_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028325944705967455610000008325424935115979189_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019638048640724421680000009219378204957398912_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000028325944705967455610000008325424935115979189_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000070829654871651105900000013958000543360396161_",
    d: "M137.9,70.6c-5.3-14.7-17.1-26.6-31.8-32l0.1-0.2 c14.7,5.4,26.6,17.3,31.9,32.1L137.9,70.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026869650764968714280000014258539433126934450_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070829654871651105900000013958000543360396161_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000026869650764968714280000014258539433126934450_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000165234056032814609140000002399493555546190781_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049213795351627549070000017092695958798763700_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165234056032814609140000002399493555546190781_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.1,
    y: 37.5,
    style: {
      clipPath: "url(#SVGID_00000049213795351627549070000017092695958798763700_)",
      fill: "#808080"
    },
    width: 34,
    height: 34.1
  })))))), /*#__PURE__*/React.createElement("g", null, _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000022520337020643318530000008177976382723963010_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000123414814244156771970000012420253512199711134_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022520337020643318530000008177976382723963010_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000123414814244156771970000012420253512199711134_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000052818946787910005080000015051000867915169949_",
    d: "M140.2,101c1-4.1,1.5-8.3,1.5-12.6 c0-2.3-0.1-4.5-0.4-6.7l-1.2,0.1c0.3,2.2,0.4,4.4,0.4,6.6c0,4.1-0.5,8.3-1.4,12.3L140.2,101z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165919485071200841890000003779962112875578553_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052818946787910005080000015051000867915169949_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000165919485071200841890000003779962112875578553_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000062893264226328486710000004829439518160427453_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013904264195169765010000017812653474416398267_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062893264226328486710000004829439518160427453_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 80.7,
    style: {
      clipPath: "url(#SVGID_00000013904264195169765010000017812653474416398267_)",
      fill: "#808080"
    },
    width: 4.7,
    height: 21.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000078009659368054038760000016528701229047665589_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039850108871981696130000006341329429296627613_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078009659368054038760000016528701229047665589_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039850108871981696130000006341329429296627613_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000119804057294405813050000008608363386637773740_",
    d: "M139.6,100.3c0.9-3.9,1.3-7.9,1.3-11.9 c0-2.1-0.1-4.1-0.4-6.1h0.2c0.2,2,0.4,4.1,0.4,6.2c0,4-0.5,8-1.3,11.9L139.6,100.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121979869187514072910000007442355451772464319_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119804057294405813050000008608363386637773740_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000121979869187514072910000007442355451772464319_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000161589274301510672900000002498187362633235844_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005237991428063173390000008035632804387952256_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161589274301510672900000002498187362633235844_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138.6,
    y: 81.2,
    style: {
      clipPath: "url(#SVGID_00000005237991428063173390000008035632804387952256_)",
      fill: "#808080"
    },
    width: 3.5,
    height: 20.1
  })))))), /*#__PURE__*/React.createElement("g", null, _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000158729520509872974180000015327396205491438239_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000179643252259371465030000004061340704837483674_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158729520509872974180000015327396205491438239_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000179643252259371465030000004061340704837483674_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000113319995198035519260000007626556441826810256_",
    d: "M106.6,137.4l0.4,1.1c13-4.9,23.8-15,29.6-27.6 l-1.1-0.5C129.9,122.8,119.3,132.6,106.6,137.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030472294899428365570000000384799326719153563_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000113319995198035519260000007626556441826810256_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000030472294899428365570000000384799326719153563_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs81 || (_defs81 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000052065500318238815170000004593489076420878979_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017487227494528300860000016752574282058785946_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052065500318238815170000004593489076420878979_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.6,
    y: 109.5,
    style: {
      clipPath: "url(#SVGID_00000017487227494528300860000016752574282058785946_)",
      fill: "#808080"
    },
    width: 32,
    height: 30.1
  })))))), /*#__PURE__*/React.createElement("g", null, _defs82 || (_defs82 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000129169867009337802000000006586356011504643514_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088844705384119399820000003322305533852431033_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129169867009337802000000006586356011504643514_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000088844705384119399820000003322305533852431033_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs83 || (_defs83 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000065048563586264011920000011156416142312496823_",
    d: "M107.3,137.7c12.4-4.9,22.8-14.5,28.5-26.6l0.2,0.1 c-5.8,12.1-16.2,21.8-28.6,26.7L107.3,137.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158017328026217130470000007999099591170735262_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065048563586264011920000011156416142312496823_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000158017328026217130470000007999099591170735262_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs84 || (_defs84 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000034802904073320586600000000921759875622533795_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116934313293919109690000003707670436030001030_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034802904073320586600000000921759875622533795_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 106.3,
    y: 110.2,
    style: {
      clipPath: "url(#SVGID_00000116934313293919109690000003707670436030001030_)",
      fill: "#808080"
    },
    width: 30.7,
    height: 28.7
  })))))), /*#__PURE__*/React.createElement("g", null, _defs85 || (_defs85 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000169517348930848802820000007842443247495313307_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013894838969195731550000013597628744345332869_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169517348930848802820000007842443247495313307_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013894838969195731550000013597628744345332869_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs86 || (_defs86 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000055703585825204910550000009240875880343552697_",
    d: "M96.2,141.5l-0.2-1.2c-5.3,0.8-10.9,0.8-16.3-0.1 l-0.2,1.2c2.8,0.5,5.7,0.7,8.6,0.7C90.8,142.1,93.5,141.9,96.2,141.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181055567966671796630000015896607428662073221_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055703585825204910550000009240875880343552697_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181055567966671796630000015896607428662073221_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs87 || (_defs87 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000054234763310168633380000001117854989400978332_",
    x: 79.5,
    y: 138.6,
    width: 16.6,
    height: 3.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005948501066908905710000009371777888636059067_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054234763310168633380000001117854989400978332_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 139.2,
    style: {
      clipPath: "url(#SVGID_00000005948501066908905710000009371777888636059067_)",
      fill: "#808080"
    },
    width: 18.6,
    height: 3.9
  })))))), /*#__PURE__*/React.createElement("g", null, _defs88 || (_defs88 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000042702558736732342530000013151326689126885808_",
    x: 11.6,
    y: 34.1,
    width: 153,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118362458924022134730000008400254869319966638_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042702558736732342530000013151326689126885808_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000118362458924022134730000008400254869319966638_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs89 || (_defs89 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005946237887810158160000005226814942447438984_",
    d: "M88.1,141.6c-2.7,0-5.4-0.2-8-0.6v-0.2 c2.6,0.4,5.3,0.6,8,0.6c2.5,0,5-0.2,7.4-0.5v0.2C93.1,141.4,90.6,141.6,88.1,141.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062160289298462944990000011006954870871555250_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005946237887810158160000005226814942447438984_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000062160289298462944990000011006954870871555250_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs90 || (_defs90 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000166672876179735131000000005294665210922427788_",
    x: 80.1,
    y: 138.6,
    width: 15.5,
    height: 3.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153686650869889257210000013175709601835437226_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000166672876179735131000000005294665210922427788_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 79.1,
    y: 139.8,
    style: {
      clipPath: "url(#SVGID_00000153686650869889257210000013175709601835437226_)",
      fill: "#808080"
    },
    width: 17.5,
    height: 2.8
  }))))))), /*#__PURE__*/React.createElement("g", null, _defs91 || (_defs91 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000084523196182735218740000010645714377504267909_",
    d: "M7.7,106.3h33.5c-0.2-0.5-0.4-1-0.5-1.5h-33"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026121802304978995330000017789704366947199423_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000084523196182735218740000010645714377504267909_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000026121802304978995330000017789704366947199423_)"
    }
  }, _defs92 || (_defs92 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000108995695701701900090000012622692345245760425_",
    x: 1.7,
    y: 24.2,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124133453491180809030000002815349722887322543_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108995695701701900090000012622692345245760425_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: 98.5,
    style: {
      clipPath: "url(#SVGID_00000124133453491180809030000002815349722887322543_)",
      fill: "#808080"
    },
    width: 34.5,
    height: 14
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpi4);
export default __webpack_public_path__ + "static/media/kpi-4.764d175f07592db7f9a5b4bfb4b216f8.svg";
export { ForwardRef as ReactComponent };